import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/atoms';
import { useProductTour } from '@/components/organisms';
import { MapIcon } from 'lucide-react';

function ProductTourHeaderButton() {
  const { isActive, restartTour } = useProductTour();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="size-9 text-primary/80 hover:text-primary"
          data-tour="header-tour-button"
          aria-label="Take the dashboard tour"
          disabled={isActive}
          onClick={restartTour}
        >
          <MapIcon className="size-5" />
        </Button>
      </TooltipTrigger>
      <TooltipContent sideOffset={8}>
        {isActive ? 'Tour in progress' : 'Take the dashboard tour'}
      </TooltipContent>
    </Tooltip>
  );
}

export { ProductTourHeaderButton };
